import { render, staticRenderFns } from "./loopDetail.vue?vue&type=template&id=a36b76a6&scoped=true&"
import script from "./loopDetail.vue?vue&type=script&lang=js&"
export * from "./loopDetail.vue?vue&type=script&lang=js&"
import style0 from "./loopDetail.vue?vue&type=style&index=0&id=a36b76a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36b76a6",
  null
  
)

export default component.exports